/*
 * paragraphAdapter — Bruecke zwischen EditorModel-Paragraph und SpellCheck-
 * Manager.
 *
 * Wird vom Manager-Wiring in `js/main.js` als `getParagraph`-Callback genutzt
 * und transformiert die Datenmodell-Form ({ formats: {text: [{start, end,
 * type}]} }) in die Form, die der Tokenizer erwartet ({ formatSpans:
 * [{start, end, format}] }).
 *
 * Phase 3: Drei Felder werden gepruefft — `text`, `note`, `info`. note und
 * info sind plain text ohne FormatSpans (`formats.note`/`formats.info`
 * existieren in seltenen Faellen, fliessen aber nicht in die Mono-Skip-
 * Logik ein — die Wellenlinie soll dort genauso erscheinen). Der `codeBlock`-
 * Pre-Filter gilt nur fuer `text`; note/info werden auch in Code-Block-
 * Absaetzen normal geprueft (Memo-Felder sind kein Code).
 *
 * Die Property-Namen unterscheiden sich, weil der Spellcheck-Layer generisch
 * ueber "Format-Spans" spricht (die spaeter auch aus anderen Quellen kommen
 * koennten), das EditorModel intern aber `type` verwendet.
 */

/**
 * @param {object|null} para - Roher EditorModel-Paragraph
 * @param {'text'|'note'|'info'} [field='text']
 * @returns {{text:string, formatSpans:Array<{start:number,end:number,format:string}>|null, codeBlock:boolean}|null}
 */
export function paragraphToCheckInput(para, field = 'text') {
    if (!para) return null
    const fieldText = field === 'text'
        ? (para.text || '')
        : (para[field] || '')
    const fieldSpans = para.formats && para.formats[field]
    const formatSpans = (fieldSpans && fieldSpans.length > 0)
        ? fieldSpans.map(s => ({ start: s.start, end: s.end, format: s.type }))
        : null
    return {
        text:        fieldText,
        formatSpans,
        // Code-Block-Pre-Filter greift nur fuer den Body-Text; Notes/Info
        // sind eigene Felder ohne Mono-Pendant.
        codeBlock:   field === 'text' ? !!para.codeBlock : false
    }
}
